import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import DoneAllIcon from "@material-ui/icons/DoneAll";

import clsx from "clsx";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Collapse from "@material-ui/core/Collapse";
import { red } from "@material-ui/core/colors";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import moment from "moment";
import { Link } from "react-router-dom";
import TaskForm from "./TaskForm";
import Button from "@material-ui/core/Button";
import CommentIcon from "@material-ui/icons/Comment";
import { Timer } from "../../custom/Timer";
import Paper from "@material-ui/core/Paper";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { compose } from "redux";
import { connect } from "react-redux";
import { getProjectFiles } from "../../../store/actions/ProjectActions";
import ProjectFiles from "../ProjectFiles";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import Loader from "../../../components/custom/loader";
import { checkA } from "../../../constant";
import { firestoreConnect } from "react-redux-firebase";
import { getCollection } from "../../../constant";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Tooltip from "@material-ui/core/Tooltip";
// import { compose } from 'redux'
import withStyles from "@material-ui/core/styles/withStyles";
import ReplayIcon from "@material-ui/icons/Replay";

import CKEditor from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { UploadAdapter } from "../../../classes/UploadAdapter";
import Editor from "../../custom/Editor/Editor";

import {
  createTask,
  createTaskReset,
} from "../../../store/actions/TaskActions";

const styles = (theme) => ({
  root: {
    width: "80%",
    margin: "auto",
    maxWidth: 800,
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: "rotate(180deg)",
  },
  avatar: {
    backgroundColor: red[500],
  },
  files: {
    textAlign: "center",
  },
  file: {
    borderRadius: 20,
    backgroundColor: "#999",
    background: "linear-gradient(to bottom, #bbb, #ddd)",
    overflow: "hidden",
    width: 200,
    height: 200,
    position: "relative",
    display: "inline-block",
    zIndex: 10,
    fontSize: 10,
    margin: 5,
    padding: 5,
  },
});

class TaskSummary extends React.PureComponent {
  state = { expanded: false, activeTab: 0, newComment: "" };

  componentDidMount() {
    this.getFiles();
    this.setState({ expanded: !this.props.enableFullView });
  }

  componentWillReceiveProps() {
    this.setState({ expanded: !this.props.enableFullView });
  }

  getFiles = () => {
    const { firestore, task, profile } = this.props;

    let coll = getCollection(profile, "files");
    if (coll != "Jassu") {
      firestore
        .collection(coll)
        .where("parentId", "==", task.id)
        .get()
        .then(
          (querySnapshot) => {
            let files = querySnapshot.docs.map((doc) => ({
              ...doc.data(),
              id: doc.id,
              sortDate: parseInt(
                moment(doc.data().timeCreated).format("YMMDDhhmmss")
              ),
            }));

            files.sort((a, b) => {
              return b.sortDate - a.sortDate;
            });

            this.setState({ files });
          },
          (err) => {
            console.error("Jassu files err : ", err);
          }
        );
    }
  };

  deleteTask = () => {
    let con = window.confirm("Are you sure, you want to delete this task?");
    if (con) {
      const { firestore, profile, history, task } = this.props;
      const { id } = task;

      firestore
        .collection(getCollection(profile, "tasks"))
        .doc(id)
        .delete()
        .then(
          () => {
            // history.push('/tasks');
          },
          (err) => {}
        );
    }
  };

  render() {
    const { task, enableFullView, profile, firestore, classes } = this.props;
    const {
      id,
      title,
      content,
      createdAt,
      complete,
      assignee,
      priority,
    } = task;
    const { activeTab, expanded, files, newComment } = this.state;

    return (
      <div>
        <Card style={{ marginBottom: 20, marginTop: -3 }}>
          <CardHeader
            style={{ padding: 10 }}
            avatar={
              <Avatar aria-label="recipe" className={classes.avatar}>
                T
              </Avatar>
            }
            action={
              enableFullView ? (
                <Link to={"/task/" + id} key={id}>
                  <IconButton aria-label="settings">
                    <OpenInNewIcon />
                  </IconButton>
                </Link>
              ) : null
            }
            title={title}
            subheader={moment(createdAt.toDate()).calendar()}
          />
          <CardContent style={{ padding: 10, position: "relative" }}>
            <Timer
              css={!enableFullView ? { right: 0, top: -58 } : {}}
              {...task}
            />

            <div>
              <strong>Priority</strong> : {priority}
            </div>

            <div>
              <strong>Assignee</strong> :
              {assignee &&
                assignee.length &&
                assignee.map((user, i) => {
                  return (
                    <span key={user.id}>
                      {" "}
                      {i != 0 && ","} {user.displayName}
                    </span>
                  );
                })}
            </div>

            {/* <div dangerouslySetInnerHTML={{ __html: content }}></div> */}
          </CardContent>

          {!enableFullView && (
            <div style={{ padding: 10 }}>
              <strong>Details</strong> :
              <div dangerouslySetInnerHTML={{ __html: content }}></div>
              <Editor
                ID={task.id}
                saveBtnClick={(comments) => {
                  let MainTask = { ...task };
                  let newTask = { ...task, addComment: true, edit: false };

                  if (!newTask.edit) newTask.edit = false;
                  if (!newTask.reopen) newTask.reopen = false;
                  if (!newTask.complete) newTask.complete = false;

                  let allCommentsInThisTask = MainTask && MainTask.comments;
                  if (
                    !allCommentsInThisTask ||
                    typeof allCommentsInThisTask != "object"
                  ) {
                    allCommentsInThisTask = [];
                  }

                  if (
                    comments &&
                    MainTask &&
                    (MainTask.reopen ||
                      MainTask.complete ||
                      MainTask.addComment)
                  ) {
                    allCommentsInThisTask.unshift({
                      comments,
                      createdAt: new Date(),
                      authorDisplayName: profile.displayName || "",
                      authorId: profile.id,
                      initials: profile.initials,
                    });
                  }

                  newTask.comments = allCommentsInThisTask;

                  this.props.createTask(newTask, task);
                  this.props.createTaskReset();
                }}
              />
              {/* <CKEditor
                editor={ClassicEditor}
                data={newComment}
                onInit={(editor) => {
                  var pluginName = "newplugin";
                  editor.ui.addButton("Newplugin", {
                    label: "My New Plugin",
                    command: "OpenWindow",
                    icon:
                      CKEditor.plugins.getPath("newplugin") +
                      "mybuttonicon.gif",
                  });
                  // var cmd = editor.addCommand("OpenWindow", {
                  //   exec: showMyDialog,
                  // });
                  // You can store the "editor" and use when it is needed.
                  console.log("Editor is ready to use!", editor);
                }}
                onChange={(event, editor) => {
                  const newComment = editor.getData();
                  // console.log( { event, editor, data } );

                  //newComment
                  this.setState({ newComment });

                  // this.handleEditorChange(data);
                }}
                onBlur={(event, editor) => {
                  // console.log( 'Blur.', editor );
                }}
                onFocus={(event, editor) => {
                  // console.log( 'Focus.', editor );
                }}
                onInit={(editor) => {
                  editor.ui.view.editable.element.style.height = "200px";
                  editor.plugins.get(
                    "FileRepository"
                  ).createUploadAdapter = function (loader) {
                    return new UploadAdapter(
                      loader,
                      task.id,
                      profile,
                      firestore
                    );
                  };
                }}
                config={{
                  // plugins: ["CKFinder"],
                  // toolbar: ["ckfinder"],
                  ckfinder: {
                    // Upload the images to the server using the CKFinder QuickUpload command.
                    // uploadUrl:
                    //   "https://example.com/ckfinder/core/connector/php/connector.php?command=QuickUpload&type=Images&responseType=json",
                    // Define the CKFinder configuration (if necessary).
                    options: {
                      resourceType: "All",
                    },
                  },
                }}
              /> */}
              <div>
                {task &&
                task.comments &&
                typeof task.comments == "object" &&
                task.comments.length > 0 ? (
                  task.comments.map((comment, i) => {
                    return (
                      <React.Fragment key={"comment-" + i}>
                        <CardHeader
                          style={{ padding: 10 }}
                          avatar={
                            <Avatar
                              aria-label="recipe"
                              className={classes.avatar}
                            >
                              {comment.initials || "C"}
                            </Avatar>
                          }
                          title={comment.authorDisplayName}
                          subheader={moment(createdAt.toDate()).calendar()}
                        />
                        <CardContent>
                          {/* {comment.comments} */}
                          <div
                            dangerouslySetInnerHTML={{
                              __html: comment.comments,
                            }}
                          ></div>
                        </CardContent>
                      </React.Fragment>
                    );
                  })
                ) : (
                  <CardContent>
                    <p>There are no files for this task</p>
                  </CardContent>
                )}
              </div>
            </div>
          )}

          {enableFullView && (
            <CardActions disableSpacing style={{ padding: 0 }}>
              {checkA(profile) && !complete && (
                <TaskForm
                  task={{ ...task, edit: true }}
                  btn={(onClick) => {
                    return (
                      <Tooltip title="Edit">
                        <IconButton onClick={onClick} aria-label="Edit">
                          <EditIcon />
                        </IconButton>
                      </Tooltip>
                    );
                  }}
                />
              )}

              {checkA(profile) && (
                <Tooltip title="Edit">
                  <IconButton onClick={this.deleteTask} aria-label="Edit">
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
              )}

              {!complete && (
                <TaskForm
                  task={{ ...task, complete: true, edit: false }}
                  btn={(onClick) => {
                    return (
                      <Tooltip title="Complete">
                        <IconButton onClick={onClick} aria-label="Complete">
                          <DoneAllIcon />
                        </IconButton>
                      </Tooltip>
                    );
                  }}
                />
              )}

              {complete && (
                <TaskForm
                  task={{ ...task, reopen: true, complete: false, edit: false }}
                  btn={(onClick) => {
                    return (
                      <Tooltip title="Reopen">
                        <IconButton onClick={onClick} aria-label="Add Comment">
                          <ReplayIcon />
                        </IconButton>
                      </Tooltip>
                    );
                  }}
                />
              )}

              {!complete && (
                <TaskForm
                  task={{ ...task, addComment: true, edit: false }}
                  btn={(onClick) => {
                    return (
                      <Tooltip title="Add Comment">
                        <IconButton onClick={onClick} aria-label="Add Comment">
                          <CommentIcon />
                        </IconButton>
                      </Tooltip>
                    );
                  }}
                />
              )}

              <Tooltip title="Attach File">
                <IconButton
                  style={{ position: "relative" }}
                  aria-label="Attach File"
                >
                  <AttachFileIcon />
                  <ProjectFiles
                    newFileUploaded={this.getFiles}
                    projectId={task.id}
                    small
                    profile={profile}
                    firestore={firestore}
                  />
                </IconButton>
              </Tooltip>

              {
                <IconButton
                  className={clsx(classes.expand, {
                    [classes.expandOpen]: expanded,
                  })}
                  onClick={() => {
                    this.setState({ expanded: !this.state.expanded });
                  }}
                  aria-expanded={expanded}
                  aria-label="show more"
                >
                  <ExpandMoreIcon />
                </IconButton>
              }
            </CardActions>
          )}
          {enableFullView && (
            <>
              <Collapse in={expanded} timeout="auto" unmountOnExit>
                <Paper square>
                  <Tabs
                    value={activeTab}
                    indicatorColor="primary"
                    textColor="primary"
                    onChange={(tab, val) => {
                      this.setState({ activeTab: val });
                    }}
                  >
                    <Tab label="Details" />
                    <Tab label="Comments" />
                    <Tab label="Files" />
                  </Tabs>
                </Paper>
                {activeTab == 0 ? (
                  <CardContent>
                    <div dangerouslySetInnerHTML={{ __html: content }}></div>
                  </CardContent>
                ) : null}

                {activeTab == 1 && (
                  <Card
                    style={{ padding: 10, margin: 20, backgroundColor: "#eee" }}
                  >
                    <Typography>Comments</Typography>

                    {task &&
                    task.comments &&
                    typeof task.comments == "object" &&
                    task.comments.length > 0 ? (
                      task.comments.map((comment, i) => {
                        return (
                          <React.Fragment key={"comment-" + i}>
                            <CardHeader
                              style={{ padding: 10 }}
                              avatar={
                                <Avatar
                                  aria-label="recipe"
                                  className={classes.avatar}
                                >
                                  {comment.initials || "C"}
                                </Avatar>
                              }
                              title={comment.authorDisplayName}
                              subheader={moment(createdAt.toDate()).calendar()}
                            />
                            <CardContent>
                              {/* {comment.comments} */}
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: comment.comments,
                                }}
                              ></div>
                            </CardContent>
                          </React.Fragment>
                        );
                      })
                    ) : (
                      <CardContent>
                        <p>There are no files for this task</p>
                      </CardContent>
                    )}
                  </Card>
                )}
                {activeTab == 2 && files ? (
                  files.length > 0 ? (
                    <TableContainer style={{ marginTop: 20, marginBottom: 20 }}>
                      <Table size="small" aria-label="a dense table">
                        <TableHead>
                          <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>Type</TableCell>
                            <TableCell>Created By</TableCell>
                            <TableCell align="right">Created At</TableCell>
                            <TableCell align="right">Open</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {files.map(
                            ({
                              id,
                              name,
                              userName,
                              contentType,
                              timeCreated,
                              url,
                            }) => {
                              return (
                                <TableRow key={id}>
                                  <TableCell
                                    style={{ wordBreak: "break-word" }}
                                  >
                                    {name}
                                  </TableCell>
                                  <TableCell>{contentType}</TableCell>
                                  <TableCell>{userName}</TableCell>
                                  <TableCell align="right">
                                    {moment(timeCreated).format("DD-MM-Y")}
                                  </TableCell>
                                  <TableCell align="right">
                                    <a target="_blank" href={url}>
                                      <IconButton>
                                        <OpenInNewIcon />
                                      </IconButton>
                                    </a>
                                  </TableCell>
                                </TableRow>
                              );
                            }
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  ) : (
                    <CardContent>
                      <p>There are no files for this task</p>
                    </CardContent>
                  )
                ) : null}
              </Collapse>
            </>
          )}
        </Card>
      </div>
    );
  }
}

// const mapSateToProps = (state, ownProps) => {
//   const files = state.firestore.ordered[getCollection(state.firebase.profile, 'files')] || [];

//   files.sort((a, b) => {
//     return b.createdAt - a.createdAt;
//   });

//   return {
//     files,
//   }
// }

const mapDispatchToProps = (dispatch) => {
  return {
    createTask: (task, id) => dispatch(createTask(task, id)),
    createTaskReset: () => dispatch(createTaskReset()),
  };
};

export default compose(
  // connect(mapSateToProps),
  connect(null, mapDispatchToProps),
  firestoreConnect((props) => [])
  // firestoreConnect((props) => {
  //   if (props.task && props.task.id)
  //     return [
  //       {
  //         collection: getCollection(props.profile, 'files'),
  //         where: ['parentId', '==', props.task.id]
  //       },
  //     ]

  //     else return []
  // })
)(withStyles(styles)(TaskSummary));
